import React from 'react';
import { withRouter } from 'react-router';
import SelectInput from 'react-select';

const customStyle = {
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isFocused &&  '#B69D73 !important',
    color: state.isFocused &&  'white !important'
  })
}

const Select = ({ 
  onChangeHandler, 
  handleMultiChange, 
  list,  
  placeholder,  
  styles, 
  prefixStyles,
  name, 
  defaultValue, 
  isClear = true, 
  disabled = false, 
  isSearchable = true,
  indicator = true,
  info_type,
  components
}) => {
  return (
    <SelectInput
      onInputChange={onChangeHandler && ((event) => onChangeHandler(event, name, info_type))}
      onChange={(value) => handleMultiChange(value, name, info_type)}
      name={name}
      id={name}
      isSearchable={isSearchable}
      options={list}
      className={styles}
      placeholder={placeholder}
      classNamePrefix={prefixStyles}
      isClearable={isClear}
      components={components}
      defaultValue={defaultValue}
      isDisabled={disabled}
      indicator={indicator}
      styles={customStyle}
    />
  )
}

export default Select;